// What an import dialog shows when its request fails: a string, or for a
// paywall refusal the message with an Upgrade link.
//
// The server's own wording wins: a quota refusal (402) carries the upgrade
// message that matches the dialog the paywall interceptor has just opened, and
// routes/entries.js sends its size and plan refusals the same way. An axios
// error is never shown raw — `JSON.stringify(axiosError)` renders the whole
// request config, headers and posted body into the dialog.
import * as React from 'react'
import { isPaywallCode } from '../Paywall/paywallCopy'

const DEFAULT_MESSAGE =
    'Something went wrong with this import. Please try again.'

// A refusal stays on the dialog after the upgrade dialog is closed, so it
// carries its own way to upgrade.
function withUpgradeLink(message, code) {
    const returnPath = window.location.pathname + window.location.search
    const href = `/upgrade?reason=${encodeURIComponent(
        code
    )}&return=${encodeURIComponent(returnPath)}`
    return (
        <>
            {message}{' '}
            <a href={href} data-testid="import-error-upgrade">
                Upgrade
            </a>
        </>
    )
}

export function importErrorMessage(error, fallback = DEFAULT_MESSAGE) {
    const response = error && error.response
    const data = response && response.data
    const candidates = [
        data && data.errormsg,
        data && data.error,
        data && data.message,
        typeof data === 'string' && !data.startsWith('<') ? data : null,
    ]
    const message = candidates.find(
        candidate => typeof candidate === 'string' && candidate.trim()
    )
    if (response && response.status === 402 && isPaywallCode(data && data.code))
        return withUpgradeLink(
            message || "You've reached a limit of the free plan.",
            data.code
        )
    if (message) return message
    if (response && response.status === 402)
        return "You've reached a limit of the free plan. Upgrade to continue."
    if (error && error.request && !response)
        return 'Could not reach the server. Check your connection and try again.'
    return fallback
}
